export class User {
  constructor () {
    this.id = '';
    this.firstname = '';
    this.lastname = '';
    this.password = '';
    this.username = '';
    this.facilityIds = [];
    this.communityId = '';
    this.lastConnection = '';
    this.mail = '';
  }
}